import styled, { css } from "styled-components/native";
import { gray_one, light_black, mid_blue } from "../../StyleHelpers";
import { TextInput } from "react-native-paper";
import { Props, StyledViewProps } from "./model";

export const StyledInput = styled(TextInput)<Props>`
	background-color: ${(props) => (props.disabled ? gray_one : light_black)};
	color: ${mid_blue};
	width: 100%;
	height: ${(props) => (props.height ? `${props.height}px` : "80px")};
	padding-left: 10px;
	flex-grow: 1;
`;

export const StyledTextError = styled.Text`
	margin-left: 30px;
	font-size: 18px;
	color: #ef877f;
`;

export const StyledText = styled.Text`
	text-align: right;
	margin-left: 30px;
	font-size: 18px;
	color: #ffffff;
`;

export const StyledErrorContent = styled.View<{ isNarrow?: boolean }>`
	display: flex;
	justify-content: center;

	height: ${({ isNarrow }) => (isNarrow ? "1.5rem" : "2.5rem")};
`;

export const StyledView = styled.View<StyledViewProps>`
	flex-grow: 0;
	flex-shrink: 1;
	flex-basis: 100%;
	height: 100%;
	${(props) =>
		props.addLeftSpacing &&
		css`
			margin-left: 20px;
		`}
	${(props) =>
		props.addRightSpacing &&
		css`
			margin-right: 20px;
		`}
`;

export const fontConfig = {
	web: {
		light: {
			fontWeight: 300,
		},
		regular: {
			fontWeight: 400,
		},
		medium: {
			fontWeight: 500,
		},
		bold: {
			fontWeight: 700,
		},
	},
	android: {
		light: {
			fontWeight: 300,
		},
		regular: {
			fontWeight: 400,
		},
		medium: {
			fontWeight: 500,
		},
		bold: {
			fontWeight: 700,
		},
	},
};
